// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"8d8bb16a","787":"cfcb9d1b"}[chunkId] + ".chunk.js";
};